<template>
  <PComponentLoader :loading="loading" :full-screen="false">
    <CContainer>
      <div class="d-flex align-items-center justify-content-end" v-if="showAdvanced">
        <label class="m-0">{{ $pgettext('event_template.label', 'Advanced settings') }}</label>
        <CSwitch class="ml-2 mt-2" color="primary" variant="3d" size="sm"
                 :checked="advanced('logo_on_photo')"
                 @update:checked="setAdvanced({type:'logo_on_photo', value: !advanced('logo_on_photo')})"
        />
      </div>
    </CContainer>
    <div class="d-flex justify-content-between align-items-start">
      <div>
        <h5 class="main-header mb-1" v-translate translate-context="event_gallery">Photo branding</h5>
        <p class="text-help-dark">
          <translate translate-context="event_wizard.label">
            Add a logo or banner that wil be applied at the bottom of every event photo
          </translate>
        </p>
      </div>
    </div>
    <hr class="mt-4">
    <LogoSetEditor
      v-if="!loading"
      in_tab
      :data="step_logo_on_photo"
      :get_upload_intent="get_upload_intent"
      :get_upload_intent_public_url="get_upload_intent_public_url"
      allow_empty
      :advanced="advanced('logo_on_photo')"
      @save="onSave"
      @updatePreview="$emit('preview',$event)"
    />
  </PComponentLoader>
</template>

<script>
import LogoSetEditor from "@/domain/logoSet/LogoSetEditor.vue";
import {mapActions, mapGetters} from "vuex";
import PComponentLoader from "@/domain/core/components/PComponentLoader.vue";

export default {
  name: "TabLogoOnPhoto",
  components: {PComponentLoader, LogoSetEditor},
  props: {
    get_upload_intent: {
      type: Function,
      required: true
    },
    get_upload_intent_public_url: {
      type: Function,
      required: true,
    }
  },
  data() {
    return {
      form: {},
      loading: true,
    }
  },
  computed: {
    ...mapGetters('eventGallery', [
      'step_logo_on_photo',
    ]),
    ...mapGetters('eventWizard', [
      'advanced',
    ]),
    showAdvanced() {
      return this.hasPerm('advanced.customize_logo_on_photo')
    },
  },
  emits: ['save', 'preview'],
  methods: {
    ...mapActions('eventGallery', [
      'fetchTabData',
    ]),
    ...mapActions('eventWizard', [
      'setAdvanced',
    ]),
    async onSave(data) {
      await this.emitPromised('save', data)
    },
  },
  async mounted() {
    await this.fetchTabData('logo_on_photo')
    this.loading = false
  }
}
</script>